import { useState, useEffect } from 'react'
import { useAppState, useAppDispatch } from './Context'
import { IconMapMarker } from '@react/common/icons'

function MapMarker({ location }) {
  const [isSelected, setIsSelected] = useState(false)
  const { selectedLocation } = useAppState()
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (selectedLocation === location) {
      setIsSelected(true)
    } else {
      setIsSelected(false)
    }
  }, [selectedLocation])

  const handleClick = (location) => {
    if (selectedLocation === location) {
      dispatch({ type: 'setSelectedLocation', payload: null })
    } else {
      dispatch({ type: 'setSelectedLocation', payload: location })
    }
  }

  return (
    <div className={`map-location ${isSelected ? 'map-location--selected' : ''}`}>
      <a
        href={location.detailsUrl}
        data-modal="content"
        data-modal-use-custom-close="true"
        className="relative cursor-pointer map-marker"
        onClick={() => handleClick(location)}
      >
        <IconMapMarker className="w-10 transition-transform xl:w-12" />
      </a>
    </div>
  )
}

export default MapMarker
